(function () {
  'use strict';

  angular.module('app').component('transportationContentPage', transportationContentDetailCtrl());

  function transportationContentDetailCtrl() {
    return {
      bindings: {},
      controller: TransportationContentDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/transportation-contents/transportation-content-page.component.html',
    };
  }

  TransportationContentDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'LanguageService',
    'TransportationContentService',

    // Angular downgraded service
    'sessionService',
  ];

  function TransportationContentDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    LanguageService,
    TransportationContentService,

    // Angular downgraded service
    sessionService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_transportation_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.transportationId = $routeParams.transportationId; // optional from modal
    vm.websiteId = $routeParams.WSID;

    // Methods
    vm.onTransportationContentSaved = onTransportationContentSaved;
    vm.onTransportationContentCanceled = onTransportationContentCanceled;

    // Initializers
    getLanguages();
    // getTransportationContent();

    function getLanguages() {
      const websiteStored = sessionService
        .getSelectedAccountCompany()
        .websites.find((x) => x.id === vm.websiteId);

      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        const languages = data.items;

        vm.defaultLanguage = languages.find((x) => x.id === websiteStored.language_id).lang; // use .lang
        vm.additionalLanguages = languages
          .filter((x) => websiteStored.language_ids.includes(x.id))
          .filter((y) => y.id !== websiteStored.language_id);

        // vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        // vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getTransportationContent();
      });
    }

    function getTransportationContent() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        TransportationContentService.getTransportationContent(itemId, vm.defaultLanguage).then(
          function (data) {
            vm.item = data;

            vm.loadingItem = false;
          }
        );
      } else {
        vm.item = {};
      }
    }

    function onTransportationContentSaved(item) {
      $location.path(`/transportation_contents/${item.id}`).search({ WSID: vm.websiteId });
    }

    function onTransportationContentCanceled() {
      $location.path(`/transportation_contents`).search({ WSID: vm.websiteId });
    }
  }
})();
